<template>
  <div>
    <router-link
      :to="`/booking?page=${getPages}&currentPage=${curPage}`"
      tag="p"
      class="dashboard__back"
      >Back</router-link
    >
    <div class="dashboard__booking-profile" v-if="bookingDetail">
      <div
        class="dashboard__booking-profile-img"
        v-if="bookingDetail.status !== 'pending'"
        :style="{
          backgroundImage: 'url(' + bookingDetail.user_kyc.photo + ')'
        }"
      ></div>
      <div class="dashboard__booking-profile-detail">
        <router-link
          tag="p"
          :to="'/member-details/' + bookingDetail.user_id"
          class="dashboard__booking-profile-name"
          style="cursor: pointer"
        >
          {{
            bookingDetail.status == "pending"
              ? bookingDetail.user_kyc.firstname
              : bookingDetail.user_kyc.fullname
          }}
        </router-link>
        <p class="dashboard__booking-profile-membership">
          Member since {{ formatDate(bookingDetail.user_kyc.created_at) }}
        </p>
        <p class="dashboard__booking-profile-age">
          {{ bookingDetail.user_kyc.gender }}
        </p>
        <p class="dashboard__booking-profile-employment">
          {{ bookingDetail.user_kyc.employment_status }}
        </p>
        <p
          class="text-success dashboard__bookingDetail-status"
          v-if="bookingDetail.status == 'accepted'"
        >
          Booking Approved
          <span v-if="bookingDetail.action_by"
            >By: {{ bookingDetail.action_by | capitalize }}</span
          >
        </p>
        <p
          class="text-danger dashboard__bookingDetail-status"
          v-if="bookingDetail.status == 'rejected'"
        >
          Booking Declined
          <span v-if="bookingDetail.action_by"
            >By: {{ bookingDetail.action_by | capitalize }}</span
          >
        </p>
        <p
          class="text-success dashboard__bookingDetail-status"
          v-if="bookingDetail.status == 'paid'"
        >
          Paid
        </p>
        <div v-if="returnedRejectionReasons.length > 0">
          <p
            class="dashboard__booking-profile-employment"
            style="font-weight: 600"
          >
            Reasons for declining booking:
          </p>

          <span
            class="dashboard__booking-profile-employment"
            v-for="(returnedRejectionReason, index) in returnedRejectionReasons"
            :key="index"
          >
            {{ returnedRejectionReason
            }}<span v-if="index + 1 != returnedRejectionReasons.length">,</span>
          </span>
        </div>
      </div>

      <div class="form__action dashboard__booking-profile-action">
        <div class="form__action-wrap">
          <div>
            <button
              type="button"
              class="dashboard__booking-profile-decline"
              @click="toggleDeclineOptionModal"
              v-if="
                bookingDetail.status == 'accepted' ||
                  bookingDetail.status == 'pending'
              "
            >
              <svgicon
                icon="spinner"
                v-if="showDeclineLoader"
                class="button__loader_red"
              ></svgicon>
              Decline
            </button>
            <button
              type="button"
              class="cta_btn dashboard__booking-profile-approve"
              @click="toggleApproveWarningModal"
              v-if="
                bookingDetail.status == 'rejected' ||
                  bookingDetail.status == 'pending'
              "
            >
              <svgicon
                icon="spinner"
                v-if="showAcceptLoader"
                class="button__loader"
              ></svgicon>
              Approve booking
            </button>

            <button
              type="button"
              class="alt_btn dashboard__booking-profile-approve"
              @click="toggleApproveGuarantorModal"
              v-if="bookingDetail.guarantor_approved === false"
            >
              <svgicon
                icon="spinner"
                v-if="showAcceptLoader"
                class="button__loader"
              ></svgicon>
              Approve guarantor
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="dashboard__booking" v-if="bookingDetail">
      <div class="dashboard__manageListing-individual-header">
        <p class="dashboard__manageListing-individual-heading">
          Subscription Details
        </p>
      </div>
      <div class="dashboard__booking-space">
        <div class="dashboard__booking-space-info">
          <p class="dashboard__booking-space-info-title">Space name</p>
          <p
            class="
              dashboard__booking-space-info-text
              dashboard__manageListing-individual-location
            "
            @click="showMap"
          >
            {{ bookingDetail.space_name | capitalize }}
          </p>
        </div>
        <div class="dashboard__booking-space-info">
          <p class="dashboard__booking-space-info-title">Host name</p>
          <router-link
            :to="'/member-details/' + bookingDetail.host_user_id"
            tag="p"
            class="dashboard__booking-space-info-text"
            style="cursor: pointer"
          >
            {{ bookingDetail.host.fullname | capitalize }}
          </router-link>
        </div>
        <div class="dashboard__booking-space-info">
          <p class="dashboard__booking-space-info-title">Host phone</p>
          <p class="dashboard__booking-space-info-text">
            {{ bookingDetail.host.phone | capitalize }}
          </p>
        </div>
        <div class="dashboard__booking-space-info">
          <p class="dashboard__booking-space-info-title">Host email</p>
          <p class="dashboard__booking-space-info-text">
            {{ bookingDetail.host.email | capitalize }}
          </p>
        </div>
        <div class="dashboard__booking-space-info">
          <p class="dashboard__booking-space-info-title">Space type</p>
          <p class="dashboard__booking-space-info-text">
            {{ bookingDetail.space_type | capitalize }}
          </p>
        </div>
        <div class="dashboard__booking-space-info">
          <p class="dashboard__booking-space-info-title">Subcription Type</p>
          <p class="dashboard__booking-space-info-text">
            {{ bookingDetail.booking_type }}
            |
            {{ bookingDetail.sub_plan | capitalize }}
          </p>
        </div>
        <div class="dashboard__booking-space-info">
          <p class="dashboard__booking-space-info-title">Price</p>
          <p
            class="
              dashboard__booking-space-info-text
              dashboard__manageListing-individual-location
            "
            @click="togglePricingBreakdownModal"
            v-if="bookingDetail.price_template"
            v-html="sumPrices(bookingDetail.price_template)"
          ></p>
        </div>
        <div class="dashboard__booking-space-info">
          <p class="dashboard__booking-space-info-title">Booking date</p>
          <p class="dashboard__booking-space-info-text">
            {{ formatDate(bookingDetail.created_at) }}
          </p>
        </div>
        <div class="dashboard__booking-space-info">
          <p class="dashboard__booking-space-info-title">Start date</p>
          <p class="dashboard__booking-space-info-text">
            {{ formatDate(bookingDetail.start_date) }}
          </p>
        </div>
        <div class="dashboard__booking-space-info">
          <p class="dashboard__booking-space-info-title">
            {{
              bookingDetail.sub_plan == "daily" ? "End date" : "Renewal date"
            }}
          </p>
          <p class="dashboard__booking-space-info-text">
            {{ formatDate(bookingDetail.end_date) }}
          </p>
        </div>
        <div
          class="dashboard__booking-space-info"
          v-if="bookingDetail.sub_plan == 'daily'"
        >
          <p class="dashboard__booking-space-info-title">
            Number of days booked
          </p>
          <p class="dashboard__booking-space-info-text">
            {{
              Math.floor(
                (new Date(bookingDetail.end_date) -
                  new Date(bookingDetail.start_date)) /
                  (1000 * 60 * 60 * 24)
              )
            }}
            days
          </p>
        </div>
      </div>
    </div>
    <div
      class="dashboard__booking"
      v-if="
        bookingDetail &&
          (bookingDetail.guarantor_approved ||
            bookingDetail.guarantor_approved === false) &&
          bookingDetail.member.userGuarantor
      "
    >
      <div class="dashboard__manageListing-individual-header">
        <p class="dashboard__manageListing-individual-heading">
          Guarantor Details
        </p>
        <p
          v-if="bookingDetail.guarantor_approved"
          class="approve_guarantor"
          style="color: #62e2aa"
        >
          Approved
        </p>
      </div>
      <div class="dashboard__booking-space">
        <div class="dashboard__booking-space-info">
          <p class="dashboard__booking-space-info-title">Name</p>
          <p class="dashboard__booking-space-info-text">
            {{ bookingDetail.member.userGuarantor.firstname | capitalize }}
            {{ bookingDetail.member.userGuarantor.lastname | capitalize }}
          </p>
        </div>
        <div class="dashboard__booking-space-info">
          <p class="dashboard__booking-space-info-title">Email</p>
          <p class="dashboard__booking-space-info-text">
            {{ bookingDetail.member.userGuarantor.email }}
          </p>
        </div>
        <div class="dashboard__booking-space-info">
          <p class="dashboard__booking-space-info-title">Phone</p>
          <p class="dashboard__booking-space-info-text">
            {{ bookingDetail.member.userGuarantor.phone }}
          </p>
        </div>
        <div class="dashboard__booking-space-info">
          <p class="dashboard__booking-space-info-title">Occupation</p>
          <p class="dashboard__booking-space-info-text">
            {{ bookingDetail.member.userGuarantor.occupation | capitalize }}
          </p>
        </div>
        <div class="dashboard__booking-space-info">
          <p class="dashboard__booking-space-info-title">Home address</p>
          <p class="dashboard__booking-space-info-text">
            {{ bookingDetail.member.userGuarantor.address }}
          </p>
        </div>
        <div class="dashboard__booking-space-info">
          <p class="dashboard__booking-space-info-title">Office address</p>
          <p class="dashboard__booking-space-info-text">
            {{ bookingDetail.member.userGuarantor.officeAddress }}
          </p>
        </div>
      </div>
    </div>
    <AppModal
      :show="showApproveWarningModal"
      :showOkButton="true"
      okButtonText="Yes, approve!"
      :showCancelBtn="true"
      @oncancel="toggleApproveWarningModal"
      @onapprove="acceptBooking"
      @onclosed="toggleApproveWarningModal"
    >
      <p class="warning__title">Approve this booking?</p>

      <p class="warning__text">
        By approving this booking, the member will be able to pay for your
        space. Do you want to proceed?
      </p>
    </AppModal>
    <AppModal
      :show="showApproveGuarantorModal"
      :showOkButton="true"
      okButtonText="Yes, approve!"
      :showCancelBtn="true"
      @oncancel="toggleApproveGuarantorModal"
      @onapprove="approveGuarantor"
      @onclosed="toggleApproveGuarantorModal"
    >
      <p class="warning__title">Approve this guarantor?</p>

      <p class="warning__text">
        By approving this guarantor, the host will be able to approve the
        booking. Do you want to proceed?
      </p>
    </AppModal>

    <AppModal
      :show="showDeclineOptionModal"
      @onclosed="showDeclineOptionModal = false"
    >
      <p class="warning__title">Decline this booking?</p>
      <p class="warning__decline-reason">
        You’re declining this booking because:
      </p>
      <div
        class="form__radio-wrap"
        v-for="(reasons, index) in getReasons"
        :key="index"
      >
        <p-check
          class="form__checkbox p-svg p-curve"
          :name="'reason' + index"
          :value="reasons.reason"
          v-model="selectedReasons"
        >
          <!-- svg path -->
          <svg slot="extra" class="svg svg-icon" viewBox="0 0 20 20">
            <path
              d="M7.629,14.566c0.125,0.125,0.291,0.188,0.456,0.188c0.164,0,0.329-0.062,0.456-0.188l8.219-8.221c0.252-0.252,0.252-0.659,0-0.911c-0.252-0.252-0.659-0.252-0.911,0l-7.764,7.763L4.152,9.267c-0.252-0.251-0.66-0.251-0.911,0c-0.252,0.252-0.252,0.66,0,0.911L7.629,14.566z"
              style="stroke: white; fill: white"
            />
          </svg>
          {{ reasons.reason }}
        </p-check>
      </div>
      <div class="form__group">
        <label for class="form__label">Other reasons</label>
        <textarea
          class="dashboard__textarea"
          row="5"
          name="others"
          v-model="otherReasons"
        ></textarea>
      </div>

      <div class="bedroom__preview-action">
        <button class="warning__cancel" @click="toggleDeclineOptionModal">
          Cancel
        </button>
        <button
          class="warning__delete"
          :disabled="selectedReasons.length == 0 && otherReasons == ''"
          @click="toggleDeclineModal"
        >
          Decline
        </button>
      </div>
    </AppModal>

    <AppModal :show="showDeclineModal" @onclosed="toggleDeclineModal">
      <p class="warning__text">
        By declining this booking, the member will not be able to book your
        space, do you want to proceed?
      </p>
      <div class="bedroom__preview-action">
        <button class="warning__cancel" @click="toggleDeclineModal">
          Cancel
        </button>
        <button class="warning__delete" @click="declineBooking">Decline</button>
      </div>
    </AppModal>

    <!-- Price breakdown modals -->
    <AppModal
      v-if="bookingDetail"
      :show="showPricingBreakdownModal"
      :showOkButton="true"
      @onapprove="togglePricingBreakdownModal"
      okButtonText="Ok"
      @onclosed="togglePricingBreakdownModal"
    >
      <p class="warning__title">Price breakdown</p>
      <p
        class="warning__decline-reason"
        v-html="'Total: ' + sumPrices(bookingDetail.price_template)"
      ></p>
      <div class="priceSummary__breakdown">
        <div class="priceSummary__breakdown-individual">
          <p class="priceSummary__breakdown-name">Rent</p>
          <p
            class="priceSummary__breakdown-price"
            v-html="
              formatAmount(
                bookingDetail.price_template.rent,
                bookingDetail.price_template.currency
              )
            "
          ></p>
        </div>
        <div class="priceSummary__breakdown-individual">
          <p class="priceSummary__breakdown-name">Spleet margin</p>
          <p
            class="priceSummary__breakdown-price"
            v-html="
              formatAmount(
                bookingDetail.price_template.commission,
                bookingDetail.price_template.currency
              )
            "
          ></p>
        </div>
        <div class="priceSummary__breakdown-individual">
          <p class="priceSummary__breakdown-name">Service charge</p>
          <p
            class="priceSummary__breakdown-price"
            v-html="
              formatAmount(
                bookingDetail.price_template.service_charge,
                bookingDetail.price_template.currency
              )
            "
          ></p>
        </div>
        <div class="priceSummary__breakdown-individual">
          <p class="priceSummary__breakdown-name">Agreement/Legal fee</p>
          <p
            class="priceSummary__breakdown-price"
            v-html="
              formatAmount(
                bookingDetail.price_template.legalFee,
                bookingDetail.price_template.currency
              )
            "
          ></p>
        </div>
        <div class="priceSummary__breakdown-individual">
          <p class="priceSummary__breakdown-name">Agency Fee</p>
          <p
            class="priceSummary__breakdown-price"
            v-html="
              formatAmount(
                bookingDetail.price_template.agencyFee,
                bookingDetail.price_template.currency
              )
            "
          ></p>
        </div>
        <div class="priceSummary__breakdown-individual">
          <p class="priceSummary__breakdown-name">Security deposit</p>
          <p
            class="priceSummary__breakdown-price"
            v-html="
              formatAmount(
                bookingDetail.price_template.security_deposit,
                bookingDetail.price_template.currency
              )
            "
          ></p>
        </div>
        <div
          class="priceSummary__breakdown-individual"
          v-if="
            bookingDetail.price_template.eviction_security_deposit !== '0.00'
          "
        >
          <p class="priceSummary__breakdown-name">Eviction security deposit</p>
          <p
            class="priceSummary__breakdown-price"
            v-html="
              formatAmount(
                bookingDetail.price_template.eviction_security_deposit,
                bookingDetail.price_template.currency
              )
            "
          ></p>
        </div>
        <div class="priceSummary__breakdown-individual">
          <p class="priceSummary__breakdown-name">Booking fee</p>
          <p
            class="priceSummary__breakdown-price"
            v-html="
              formatAmount(
                bookingDetail.price_template.booking_fee,
                bookingDetail.price_template.currency
              )
            "
          ></p>
        </div>
        <div class="priceSummary__breakdown-individual">
          <p class="priceSummary__breakdown-name">VAT</p>
          <p
            class="priceSummary__breakdown-price"
            v-html="
              formatAmount(
                bookingDetail.price_template.vat,
                bookingDetail.price_template.currency
              )
            "
          ></p>
        </div>
        <div class="priceSummary__breakdown-individual">
          <p class="priceSummary__breakdown-name">Discount</p>
          <p
            class="priceSummary__breakdown-price"
            v-html="
              formatAmount(
                '-' + bookingDetail.price_template.discount,
                bookingDetail.price_template.currency
              )
            "
          ></p>
        </div>
      </div>
    </AppModal>

    <!-- Map modal -->
    <AppModal :show="showMapModal" @onclosed="showMapModal = false">
      <div id="map" class="location__map w-100"></div>
    </AppModal>
    <loader :loader="loader"></loader>
  </div>
</template>

<script>
import {
  getBookingDetail,
  acceptBooking,
  declineBooking,
  getRejectReasons,
  approveGuarantor
} from "../../../services/booking";
import AppModal from "../resuables/modal";
import loader from "../resuables/loader";
import {
  formatReadbleDate,
  sumBookingPrice,
  formatCurrencyAmount
} from "../../utils";
let Gmap;
let Gmarker;
export default {
  name: "bookingDetail",
  components: {
    AppModal,
    loader
  },
  data() {
    return {
      profileImage:
        "https://images.unsplash.com/photo-1522529599102-193c0d76b5b6?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&w=1000&q=80",
      showApproveWarningModal: false,
      showDeclineOptionModal: false,
      showPricingBreakdownModal: false,
      showDeclineModal: false,
      spaceUnavaliable: false,
      spaceSold: false,
      damagedSpace: false,
      naturalDisaster: false,
      dateUnavailable: false,
      showMapModal: false,
      latitude: 6.437145599999999,
      longitude: 3.484465699999999,
      bookingData: null,
      showAcceptLoader: false,
      showDeclineLoader: false,
      bookingId: this.$route.params.id,
      rejectReasons: [],
      selectedReasons: [],
      otherReasons: "",
      otherReason: [],
      loader: false,
      returnedRejectionReasons: [],
      showApproveGuarantorModal: false
    };
  },
  methods: {
    toggleApproveGuarantorModal() {
      this.showApproveGuarantorModal = !this.showApproveGuarantorModal;
    },
    toggleApproveWarningModal() {
      this.showApproveWarningModal = !this.showApproveWarningModal;
    },
    toggleDeclineOptionModal() {
      this.showDeclineOptionModal = !this.showDeclineOptionModal;
    },
    togglePricingBreakdownModal() {
      this.showPricingBreakdownModal = !this.showPricingBreakdownModal;
    },
    toggleDeclineModal() {
      if (this.showDeclineOptionModal) {
        this.showDeclineOptionModal = false;
      }
      this.showDeclineModal = !this.showDeclineModal;
    },
    showMap() {
      this.showMapModal = !this.showMapModal;
      const lat = this.latitude;
      const lng = this.longitude;
      const latlng = {
        lat,
        lng
      };
      let mapOptions = {
        center: latlng,
        zoom: 14
      };
      let mapDom = document.getElementById("map");
      Gmap = new google.maps.Map(mapDom, mapOptions);
      this.createMarker();
    },
    createMarker() {
      const lat = this.latitude;
      const lng = this.longitude;
      const latlng = {
        lat,
        lng
      };
      let markerOptions = {
        position: latlng,
        map: Gmap,
        animation: google.maps.Animation.BOUNCE,
        clickable: true,
        draggable: false
      };
      Gmarker = new google.maps.Marker(markerOptions);
    },
    getBookingDetail() {
      console.log(`this fired`);
      this.loader = true;
      getBookingDetail(this.bookingId)
        .then(data => {
          if (data.statusCode == 200) {
            this.loader = false;
            this.bookingData = data.data;
          }
        })
        .catch(err => {
          this.loader = false;
          return err;
        });
    },
    formatDate(data) {
      return formatReadbleDate(data);
    },
    formatAmount(data, currency) {
      return formatCurrencyAmount(data, currency);
    },
    sumPrices(priceData) {
      return sumBookingPrice(priceData);
    },
    acceptBooking() {
      this.toggleApproveWarningModal();
      this.showAcceptLoader = true;
      acceptBooking(this.bookingId)
        .then(res => {
          if (res.status === 400) {
            this.$notification.error({
              message: "Approval failed",
              description: res.data.message
            });
          } else if (res.statusCode === 200) {
            this.bookingData.status = "accepted";
            this.$notification.success({
              message: "Booking Accepted",
              description: "Booking successfully accepted"
            });
          } else {
            this.$notification.error({
              message: "Approval failed",
              description: res.data.message
            });
          }
          this.showAcceptLoader = false;
        })
        .catch(err => {
          this.showAcceptLoader = false;
          this.$notification.error({
            message: "Approval failed",
            description: err.response.data.message
          });
        });
    },
    async declineBooking() {
      this.toggleDeclineModal();
      this.showDeclineLoader = true;
      if (this.otherReasons != "") {
        this.otherReason.push(this.otherReasons);
      }

      let reasons;
      if (this.otherReasons != "" && this.selectedReasons.length > 0) {
        reasons = {
          reject_reason: this.selectedReasons,
          other_reasons: this.otherReason
        };
      } else {
        if (this.otherReasons != "") {
          reasons = {
            other_reasons: this.otherReason
          };
        } else if (this.selectedReasons.length > 0) {
          reasons = {
            reject_reason: this.selectedReasons
          };
        }
      }
      declineBooking(this.bookingId, reasons)
        .then(res => {
          if (res.status === 400) {
            this.showDeclineLoader = false;
            this.$notification.error({
              message: "Booking decline failed",
              description: res.data.message
            });
          } else if (res.statusCode === 200) {
            this.bookingData.status = "rejected";
            this.$notification.success({
              message: "Booking Rejection",
              description: "Booking successfully rejected"
            });
            this.showDeclineLoader = false;
          } else {
            this.$notification.error({
              message: "Booking decline failed",
              description: res.data.message
            });
          }
          this.showDeclineLoader = false;
        })
        .catch(err => {
          this.showDeclineLoader = false;
          this.$notification.error({
            message: "Booking decline failed",
            description: err.response.data.message
          });
        });
    },
    async getRejectReasons() {
      let data = await getRejectReasons();
      this.rejectReasons = data.data;
    },
    approveGuarantor() {
      approveGuarantor(this.bookingId)
        .then(res => {
          if (res.statusCode === 200) {
            this.showApproveGuarantorModal = false;
            this.bookingDetail.guarantor_approved = true;
            this.$notification.success({
              message: "Guarantor Approved",
              description: "Guarantor successfully approved"
            });
          }
        })
        .catch(err => {
          this.showApproveGuarantorModal = false;
          this.$notification.error({
            message: "Forbidden",
            description:
              "You don't have the permission to perform this operation"
          });
          return err;
        });
    }
  },
  filters: {
    capitalize(value) {
      if (!value) return "";
      value = value.toString();
      return value.charAt(0).toUpperCase() + value.slice(1);
    },
    formatNowDate(value) {
      if (!value) return "";
      if (value) {
        return moment(value).fromNow();
      }
    },
    capitalizeFirstLetter(value) {
      if (!value) return "";
      if (value) {
        return value.charAt(0).toUpperCase() + value.slice(1);
      }
    }
  },
  watch: {
    bookingData(newValue) {
      if (newValue.reject_reason != null) {
        this.returnedRejectionReasons = newValue.reject_reason.split(",");
        this.returnedRejectionReasons.push(newValue.other_reject_reason);
      }
    }
  },
  computed: {
    getPages() {
      return this.$route.query.page || 0;
    },
    curPage() {
      return this.$route.query.currentPage || 1;
    },
    bookingDetail() {
      return this.bookingData;
    },
    getReasons() {
      return this.rejectReasons;
    }
  },
  mounted() {
    this.getBookingDetail();
    this.getRejectReasons();
  }
};
</script>

<style lang="scss" scoped>
.approve_guarantor {
  color: #2e48da;
  font-size: 15px;
  font-weight: 500;
  line-height: normal;
  cursor: pointer;
  margin-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/dashboard/bookingDetails.vue